<template>
    <SettingsInstallationPanel
        :show.sync="parentSettingsInstallationPanelMixin.showSettingsInstallationPanel"
        :installation="parentSettingsInstallationPanelMixin.settingsInstallation"
        @updateInstallation="$emit('updateInstallation')"
        @deleteInstallation="deleteInstallation()"
    ></SettingsInstallationPanel>
</template>

<script>
    import SettingsInstallationPanel from '../view_panels/SettingsInstallationPanel';

    export default {
        name: 'SettingsInstallationPanelMixinPanel',
        inject: ['parentSettingsInstallationPanelMixin'],
        components: { SettingsInstallationPanel },
        methods: {
            deleteInstallation() {
                this.$emit('updateInstallation');
                this.$emitInstance('refresh');
            },
        },
    };
</script>
